import { createPlugin } from '@backstage/core-plugin-api';
import {
  createTechDocsAddonExtension,
  TechDocsAddonLocations,
} from '@backstage/plugin-techdocs-react';
import { TechDocsSearch } from './components/TechDocsSearch';

export const searchPlugin = createPlugin({
  id: 'techdocs-search',
});

export const SearchAddon = searchPlugin.provide(
  createTechDocsAddonExtension({
    name: 'Search',
    location: TechDocsAddonLocations.Subheader,
    component: TechDocsSearch,
  }),
);
